import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { useWarehouseContext } from 'providers/WarehouseProvider';

import Table from 'components/common/Table';

import { putAwayApi } from 'api';

import {
  PUT_AWAY_LIST_COLUMNS,
  PUT_AWAY_FILTER_OPTIONS,
} from 'constants/putAway';

import paths from 'routes/paths';

const Putaway = () => {
  const navigate = useNavigate();

  const { selectedWarehouse } = useWarehouseContext();
  const initialFilter = { warehouse: selectedWarehouse?.id };

  const headerActions = (
    <Button
      variant="primary"
      size="sm"
      onClick={() => navigate(paths.putAwayCreate)}
    >
      Create Putaway
    </Button>
  );

  return (
    <Table
      title="Putaway"
      apiService={putAwayApi}
      sortable={true}
      columns={PUT_AWAY_LIST_COLUMNS}
      filterOptions={PUT_AWAY_FILTER_OPTIONS}
      initialFilter={initialFilter}
      headerActions={headerActions}
    />
  );
};

export default Putaway;
